<template>
    <div>
        <template v-if="loading">
            <i class="fa fa-circle-o-notch fa-spin"></i> Loading
        </template>
        <template v-else>
            <template v-if="comments.length > 0">

                <!-- More Comments Section -->
                <template v-if="comments.length < totalComments">
                    <div class="comments-more text-centered" title="Load All Comments">
                        <span class="collapsed-comments-line"></span>
                        <span class="collapsed-comments-line"></span>
                        <span class="collapsed-comments-line"></span>
                        <div class="comments-more-link" v-on:click="loadAllComments()">
                            {{ totalComments - comments.length }} More Comment<template v-if="totalComments - comments.length > 1">s</template>
                        </div>
                    </div>
                </template>

                <!-- Each actual comment -->
                <div class="media comment-box py-3" v-for="comment in comments">
                    <div class="media-body ml-4">
                        <div class="float-right" v-if="comment.UserId == user.user_id">
                            <a :href="`mailto:${comment.email}`" class="text-muted mr-2" :title="`Email ${comment.FirstName} at ${comment.email}`"><i class="fa fa-envelope"></i></a>
                            <a href="javascript:void(0)" class="text-muted mr-2" v-on:click="editComment(comment)" title="Edit Comment"><i class="fa fa-edit"></i></a>
                            <a href="javascript:void(0)" class="text-muted mr-2" v-on:click="deleteComment(comment)" title="Delete Comment"><i class="fa fa-trash"></i></a>
                        </div>
                        <span class="badge badge-info" v-if="comment.is_public">Public</span>
                        <template v-if="comment.UserId"><user-name :user="comment" /></template>
                        <template v-else>[SYSTEM]</template>
                        <span class="small text-light">
                            at {{ comment.created_at | moment('timezone', user.timezone, "MM/DD/YYYY hh:mm a") }}
                        </span>
                        <div class="mt-2">{{ comment.comment_details }}</div>
                    </div>
                </div>
            </template>
            <template v-else>
                -- No Comments --
            </template>
            <div>
                <hr/>
                <button type="button" class="btn btn-sm btn-light" @click="expandText = true" v-if="allowNewComments && !expandText">
                    <i class="fa fa-plus-circle text-success"></i> Add Comment
                </button>

                <b-form-textarea ref="commentArea" v-model="comment.comment_details" :class="{'mb-1': true, 'is-invalid': errors.comment_details}" placeholder="Add a New Comment" v-if="expandText" rows="4"></b-form-textarea>

                <button type="button" class="btn btn-sm btn-success" v-if="expandText" @click="saveComment()" :disabled="saving">
                    <template v-if="!saving">
                        <template v-if="!comment.comment_id">Add</template>
                        <template v-else>Update</template>
                        Comment
                    </template>
                    <template v-if="saving">Saving...</template>
                </button>
                <button type="button" class="btn btn-sm btn-default" v-if="expandText" @click="cancelComment()">Cancel</button>
                <span v-if="errors.comment_details" class="text-danger">
                    <template v-for="(error, key in errors.comment_details">
                        <template v-if="key > 0">, </template>{{ error }}
                    </template>
                </span>
            </div>
        </template>
    </div>
</template>

<script>
    export default {
        props: {
            assetId: {
                type: Number,
                required: true
            },

            assetType: {
                type: String,
                required: true,
            },

            sectionNumber: {
                type: Number,
                required: false,
            },

            allowNewComments: {
                type: Boolean,
                default: true,
            }
        },

        data: function() {
            return {
                user: this.$store.state.user,
                loading: true,
                saving: false,
                showAll: false,
                expandText: false,
                errors: {},
                comments: [],
                totalComments: null,
                comment: {},
            }
        },

        watch: {
            totalComments (newValue, oldValue){
                this.$emit('commentListCount', newValue);
            },
        },

        methods: {
            //Getter
            getComments(){
                //Loading?
                this.loading = true;

                let data = {assetType: this.assetType, assetId: this.assetId, showAll: this.showAll};;
                if (this.sectionNumber)
                {
                    data.section_number = this.sectionNumber;
                }

                //Get the comments
                this.$http.get('/comments/list', data)
                    .then(response => {
                        //Set the comments
                        this.comments = response.data.comments;
                        this.totalComments = response.data.total;
                    })
                    .catch(err => {

                    })
                    .then(response => {
                        //Reset loading
                        this.loading = false;
                    });
            },

            loadAllComments(){
                //Set the flag
                this.showAll = true;

                //Get the comments
                this.getComments();
            },

            saveComment(){
                //Saving
                this.saving = true;
                this.errors = {};

                //Set the asset types
                this.comment.asset_type = this.assetType;
                this.comment.asset_id = this.assetId;

                if (this.sectionNumber)
                {
                    this.comment.section_number = this.sectionNumber;
                }

                //Send it
                this.$http.post('/comments/save', this.comment)
                    .then(response => {
                        //Alert user
                        this.$toastr.success('Comment Saved');

                        //Set the comments
                        this.updateComments(response.data);

                        //Reset the helpers
                        this.resetNewComment();
                    })
                    .catch(err => {
                        //Set the errors
                        if(err.response.status === 422)
                        {
                            //Display validation errors
                            this.errors = err.response.data
                        }
                    })
                    .then(response => {
                        //Reset loading
                        this.saving = false;
                    });
            },

            deleteComment(comment){
                //Confirm
                if(!confirm('Are you sure you want to delete this comment?'))
                {
                    return;
                }

                //Deleting?

                //Send it
                this.$http.post('/comments/delete', comment)
                    .then(response => {
                        //Alert user
                        this.$toastr.success('Comment Deleted');

                        //Set the comments
                        this.updateComments(comment, true);

                        //Reset the helpers
                        this.resetNewComment();
                    })
                    .catch(err => {
                        //Set the errors
                        if(err.response.status === 422)
                        {
                            //Display validation errors
                            this.errors = err.response.data
                        }
                    })
                    .then(response => {
                        //Reset deleting
                    });
            },

            updateComments(comment, deleteMode = false){
                //Loop and reset
                for (var i = this.comments.length - 1; i >= 0; i--)
                {
                    //If the IDs match, replace it
                    if(this.comments[i].comment_id == comment.comment_id)
                    {
                        //Splice and reset
                        if(deleteMode)
                        {
                            //SPlice only
                            this.comments.splice(i, 1);
                            this.totalComments--;
                        }
                        else
                        {
                            //Splice and replace so reactivity is preserved
                            this.comments.splice(i, 1, comment);
                        }

                        //Stop here;
                        return;
                    }
                }

                //If it get here, it's a new bid. Push it
                this.comments.push(comment);
                this.totalComments++;
            },

            editComment(comment){
                //Set the data
                this.comment = JSON.parse(JSON.stringify(comment));
                this.expandText = true;
                this.$nextTick(() => this.$refs.commentArea.focus());
            },

            cancelComment(){
                //Confirm with the user
                // if(confirm('Are you sure you want to discard this comment?'))
                // {
                    this.resetNewComment()
                // }
            },

            resetNewComment(){
                //Reset the Data
                this.comment = {};
                this.expandText = false;
            }
        },

        mounted() {
            //Get the comments
            this.getComments();
        }
    }
</script>

<style>
    .comment-box {
        border-left: 2px solid #fff;
        border-top: 1px solid #f1f1f1;
    }

    .comment-box:hover {
        background: #fafafa;
        border-left: 2px solid #bb3d3d;
    }

    .comments-more {
        background: #fafafa;
        border-top: 1px solid #f1f1f1;
        position: relative;
        text-align: center;
    }

    .collapsed-comments-line {
        border-bottom: 1px solid #e6e6e6;
        display: block;
        padding-top: 12px
    }

    .comments-more-link {
        background: #fafafa;
        position: absolute;
        top: 22%;
        margin-left: auto;
        margin-right: auto;
        left: 0;
        right: 0;
        width: 140px;
    }

    .comments-more-link:hover {
        background: #ddd;
        cursor: pointer;
    }
</style>
